/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stocktake_Field_SnapshotInputs */

const vi_stocktake_field_snapshot = /** @type {(inputs: Stocktake_Field_SnapshotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chốt sổ`)
};

/**

* @param {Stocktake_Field_SnapshotInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stocktake_field_snapshot = /** @type {((inputs?: Stocktake_Field_SnapshotInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocktake_Field_SnapshotInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stocktake_field_snapshot(inputs)
});